import Skeleton from '@mui/material/Skeleton';
import { canUseDOM } from '@ps/web-core-utils';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';

import type { RootState } from '@swf/core/store';

import { PKR_CLUB_NAV_ID } from '../../../../constants';
import { useHomeGamesWidget } from '../../../../model';

import BackButton from './BackButton';
import styles from './ResultsHeader.scss';
import Summary from './Summary';

const PortalContent: React.FC = () => {
  const {
    params: { subsection }
  } = useRouteMatch<{ subsection: string }>();
  const { widgetSelect } = useHomeGamesWidget();
  const { clubSeasonSummaries: loading } = useSelector(widgetSelect.loading);
  const [, tournId] = subsection.split('-');
  const summary = useSelector((rootState: RootState) =>
    widgetSelect.clubTournamentSummary(rootState, Number(tournId))
  );

  return loading ? (
    <div className={styles.summary}>
      <div className={styles.nameSkeleton}>
        <Skeleton className={styles.skeleton} variant="text" height={30} width="100%" />
        <Skeleton className={styles.skeleton} variant="text" height={20} width="100%" />
      </div>
      <Skeleton className={styles.skeleton} variant="text" height={20} width="20%" />
    </div>
  ) : (
    <div>
      <BackButton />
      {summary && <Summary {...summary} />}
    </div>
  );
};

const ResultsHeader: React.FC = () => {
  const { widgetDispatch } = useHomeGamesWidget();
  const target = canUseDOM && document.getElementById(PKR_CLUB_NAV_ID);

  useEffect(() => {
    widgetDispatch.setUiLayout({ key: 'clubNavHidden', value: true });

    return () => {
      widgetDispatch.setUiLayout({ key: 'clubNavHidden', value: false });
    };
  }, [widgetDispatch]);

  return target ? createPortal(<PortalContent />, target as HTMLElement) : null;
};

export default ResultsHeader;
